import BasicResources from './basic-resources';
// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

class Resources {
    static createResources(parentEnv) {
        const env = parentEnv || Resources.env; // eslint-disable-line no-unused-

        /**
         * CURRICULUM/MASTER COURSE
         */
        this.getMasterCoursesCountries = env.resource('getMasterCoursesCountries')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/curriculumCountries');

        this.getMasterCourses = env.resource('getMasterCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/masterCourses');

        this.getMasterCoursesByCountry = env.resource('getMasterCoursesByCountry')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/masterCourses');

        this.getMasterCoursesByAccessStatus = env.resource('getMasterCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/masterCourses/filter');

        this.getMasterCourse = env.resource('getMasterCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/masterCourses/{masterCourseId}/version/{version}');

        /**
         * COURSES
         */
        this.getDefaultCourses = env.resource('getDefaultCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourses');

        this.getDefaultCourse = env.resource('getDefaultCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourse/{courseId}/version/{version}');

        this.getDefaultCourseForCountry = env.resource('getDefaultCourseForCountry')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourse/defaultcourses');

        this.getCourses = env.resource('getCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/defaultcourses/filter');

        this.getCoursesForCountry = env.resource('getCoursesForCountry')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses');

        this.saveDefaultCourse = env.resource('saveDefaultCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourse');

        this.publishDefaultCourse = env.resource('publishDefaultCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourse/{courseId}/publish');

        this.archiveSelectedCourse = env.resource('archiveSelectedCourse')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/genericcourse/{courseId}/{courseVersion}');

        this.saveDefaultCourses = env.resource('saveDefaultCourses')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/courses/defaultcourses');

        /**
         * SUBJECTS
         */
        this.getSubjects = env.resource('getSubjects')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('v1/subjects');

        /**
         * AUTH
         */
        this.checkUserIsAuthorised = env.resource('checkUserIsAuthorised')
            .baseUrl('@CourseManagerGatewayUrl')
            .service('checkAuthorization');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./app/helpers/resources.js